import { applyAdminImpliedFlags } from '@fox/shared/src/feature-flags';
import React, { PropsWithChildren, createContext, useContext, useMemo } from 'react';

export type Role = {
	id: string;
	features?: Array<string>;
};

/** A context storing the current user's role and feature flags */
type FeatureContext = {
	roles: Array<Role>;
	flags: Set<string>;
};

const Context = createContext<FeatureContext>({ roles: [], flags: new Set<string>() });
Context.displayName = 'FeatureContext';

/** Use where you want to bulk check flags or repeatedly check flags. Returns a Set object that will be the same as long as roles remain the same. */
export function useAccessFlags() {
	const { flags } = useContext(Context);
	return flags;
}

/** Use where you want to check if we can access a single flag */
export function useCanAccessFlag(featureFlag: string) {
	return useAccessFlags().has(featureFlag);
}

export function useRoles() {
	const { roles } = useContext(Context);
	return roles;
}

export const FeatureContextProvider: React.FC<PropsWithChildren<Pick<FeatureContext, 'roles'>>> = ({ children, roles }) => {
	// unique flags
	const flags = useMemo(() => {
		const raw = roles.flatMap(r => r.features ?? []);
		const r = new Set(applyAdminImpliedFlags(raw));
		console.log('access flags', r);
		return r;
	}, [roles]);

	return <Context.Provider value={{ roles, flags }}>{children}</Context.Provider>;
};
